var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbbleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.094 2.804c2.61 2.124 4.477 4.161 5.714 6.311m0 0a14.125 14.125 0 0 1 1.675 4.548m-1.675-4.548c1.804-.905 3.523-2.204 5.223-3.935m-5.223 3.935c-3.37 1.693-7.03 2.011-11.397 1.21m13.072 3.338c.425 2.304.334 4.837-.173 7.776m.173-7.776c-3.096.875-5.946 2.84-9.048 6.128m9.049-6.128c1.972-.557 4.045-.673 6.346-.406m-6.52 8.182-.011.062m.01-.062A10.002 10.002 0 0 0 22 12c0-5.523-4.476-10-10-10C6.477 2 2 6.477 2 12s4.477 10 10 10c1.16 0 2.274-.198 3.31-.561Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleLine);
export default __webpack_public_path__ + "static/media/dribbble_line.6be950a8cdced0b6cea5cc04e218d753.svg";
export { ForwardRef as ReactComponent };